export const getAge = (birthYear: number) => {
  const currentYear = new Date().getFullYear()
  return currentYear - birthYear
}
/**
 * 防抖函数（debounce）
 * 在指定时间内只执行最后一次调用
 * @param fn 要执行的函数
 * @param delay 延迟时间（毫秒）
 * @param immediate 是否立即执行第一次调用
 * @returns 包装后的防抖函数
 */
export function debounce<T extends (...args: any[]) => any>(
  fn: T,
  delay: number = 300,
  immediate: boolean = false
): (...args: Parameters<T>) => void {
  let timer: NodeJS.Timeout | null = null
  let hasExecuted = false
  
  return function (this: any, ...args: Parameters<T>) {
    const execute = () => {
      fn.apply(this, args)
      hasExecuted = true
    }
    
    if (immediate && !hasExecuted) {
      execute()
      return
    }
    
    if (timer) {
      clearTimeout(timer)
    }
    
    timer = setTimeout(() => {
      execute()
      timer = null
    }, delay)
  }
}

export function isToday(timestamp: number) {
  // 秒级转毫秒
  if (String(timestamp).length === 10) {
    timestamp = timestamp * 1000;
  }

  const d = new Date(timestamp);
  const today = new Date();

  return (
    d.getFullYear() === today.getFullYear() &&
    d.getMonth() === today.getMonth() &&
    d.getDate() === today.getDate()
  );
}